module.exports = __webpack_public_path__ + "img/joao.62dde8f7.png";